import React from 'react';
import PropTypes from 'prop-types';
import { renderToStaticMarkup } from 'react-dom/server';
import List from '../../../commonComponents/lists/List';
import Modal from '../../../commonComponents/modal/Modal';
import translate from '../../../commonComponents/translate';
import UserColumn from '../../../commonComponents/lists/columns/UserColumn';

const buildQueryString = surveyContext => {
  let url = '?';
  if (surveyContext && surveyContext !== 'all') {
    url += `&surveyContext=${surveyContext}`;
  }
  return url;
};
function ShowAnswersModal({ t, onClose, data, contextName, surveyContext }) {
  const { type, questionId, answerId } = data;

  const tableId = 'surveyAnswersTable';
  const query = buildQueryString(surveyContext);

  let url = `/api/survey/question/${questionId}/answers${query}`;

  switch (type) {
    case 'options':
    case 'choice':
    default:
      url += `&answer=${answerId}`;
      break;
    case 'multiple_answers':
      url += `&multipleAnswers=${answerId}`;
      break;
    case 'evaluation':
      url += `&evaluation=${answerId}`;
      break;
    case 'opinion':
      url *= `&opinion=${answerId}`;
      break;
  }

  /** HANDLE FUNCTIONS */
  const dataTransform = row => ({ ...row, context: contextName(row.surveyContext || {}) });

  /** RENDER COMPONENT */
  const columns = [
    {
      field: 'owner',
      title: t('name'),
      textAlign: 'center',
      width: 300,
      template: ({ owner }) =>
        renderToStaticMarkup((
          <div>
            {owner ?
              (<UserColumn t={t} user={owner} />)
              :
              '-'
            }
          </div>
        )),
    },
    {
      field: 'context',
      title: t('surveyReports_context'),
      textAlign: 'center',
      width: 300,
      template: ({ context }) =>
        renderToStaticMarkup((
          <span>
            {context || '-'}
          </span>
        )),
    },
  ];

  return (
    <Modal onClose={onClose} id="surveyReportModal">
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <div id="modalBody" className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            <h5>{t('surveyReports_answerTargetUsers')}</h5>
            <div id="answersSection" className="table-responsive">
              <List
                id={tableId}
                dataSourceURL={url}
                columns={columns}
                query={{}}
                dataSourceParams={{ populate: ['owner', 'team', 'surveyContext'] }}
                dataTransform={dataTransform}
              />
            </div>
            <div className="modal-buttons">
              <div className="row justify-content-end">
                <div className="col-lg-3">
                  <button
                    type="button"
                    className="btn btn-dynamic"
                    onClick={onClose}
                  >
                    {t('close')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

ShowAnswersModal.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.shape({
    questionId: PropTypes.string.isRequired,
    filters: PropTypes.shape({
      owner: PropTypes.string,
      surveyContext: PropTypes.string,
      targetTeam: PropTypes.string,
      targetUser: PropTypes.string,
      team: PropTypes.string,
    }),
    answerId: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  surveyContext: PropTypes.string.isRequired,
  contextName: PropTypes.func.isRequired,
};
ShowAnswersModal.defaultProps = {
};

export default translate(ShowAnswersModal);
